(async () => {
  const matchCookie = checkCookies('shipping-threshold-new');
  if (matchCookie) {
    const thresholdData = matchCookie[2];
    if (thresholdData.includes(Shopify.country)) {
      const threshold = parseFloat(thresholdData.split('--').pop());
      document.dispatchEvent(new CustomEvent('threshold:fetched', {
        detail: {
          threshold
        }
      }));
      return;
    }
  }

  try {
    const res = await fetch('https://shipping.app-sym.com/api/threshold-by-country', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        country: Shopify.country,
        shop: Shopify.shop
      })
    });
    const data = await res.json();

    if (data.status !== 'success') {
      const thresholdErrorEvent = new CustomEvent('threshold:error', {
        detail: {
          message: data.message
        }
      });

      document.dispatchEvent(thresholdErrorEvent);
      return;
    }

    addCookie('shipping-threshold-new', `${Shopify.country}--${data.threshold}`, 0.04);
    const threshold = parseFloat(data.threshold)
    document.dispatchEvent(new CustomEvent('threshold:fetched', {
      detail: {
        threshold
      }
    }));
  } catch (err) {
    const thresholdErrorEvent = new CustomEvent('threshold:error', {
      detail: {
        message: err
      }
    });

    document.dispatchEvent(thresholdErrorEvent);
  }
})();